(function () {
  var searchBackendConfig = window.searchBackendConfig || {};
  var backendUrl = searchBackendConfig.directBackendUrl || '';
  var shopDomain = searchBackendConfig.shopDomain || '';
  var locale = searchBackendConfig.locale || 'de';

  function directEndpoint(path) {
    return backendUrl + path;
  }

  function parseResponse(response) {
    return response.text().then(function (text) {
      return JSON.parse(text);
    }).then(function (payload) {
      return response.ok && payload.success !== false ? payload : Promise.reject(payload);
    });
  }

  function directOptions(path, options) {
    var baseOptions = options || {};
    var isGet = ['GET', undefined].includes(baseOptions.method);
    var headers = Object.assign(
      { 
        Accept: 'application/json',
        'ngrok-skip-browser-warning': 'true',
        'X-Shop-Domain': shopDomain,
        'X-Locale': locale
      },
      !isGet && { 'Content-Type': 'application/json' },
      baseOptions.headers || {}
    );
    return Object.assign({}, baseOptions, {
      credentials: 'omit',
      headers: headers,
      body: baseOptions.body
    });
  }

  function directRequest(path, options) {
    return backendUrl
      ? fetch(directEndpoint(path), directOptions(path, options)).then(parseResponse)
      : Promise.reject({ error: 'Backend URL not configured' });
  }

  function escapeHtml(value) {
    var element = document.createElement('div');
    element.textContent = value == null ? '' : String(value);
    return element.innerHTML;
  }

  function formatMoney(value, currency) {
    var amount = Number(value || 0);
    var currencyCode = currency || 'EUR';
    var formatted = (amount / 100).toLocaleString('de-DE', { style: 'currency', currency: currencyCode });
    return formatted;
  }

  function renderSearchResult(item, type) {
    var title = item.title || item.name || '';
    var imageUrl = item.image || item.featured_image || '';
    var url = item.url || item.handle ? '/products/' + item.handle : '#';
    var price = item.price || item.price_amount;
    var vendor = item.vendor || item.brand || '';
    var typeLabel = type === 'product' ? 'Produkt' : (type === 'collection' ? 'Kategorie' : 'Artikel');

    var imageMarkup = imageUrl 
      ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(title) + '" width="50" height="50" loading="lazy">'
      : '<div style="width:50px;height:50px;background:#FAF7F2;display:flex;align-items:center;justify-content:center;"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#93817B" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>';

    var priceMarkup = price 
      ? '<div class="predictive-search__item-vendor caption-with-letter-spacing">' + escapeHtml(formatMoney(price)) + '</div>'
      : '';

    return '<li class="predictive-search__list-item" role="option" aria-selected="false">' +
      '<a href="' + escapeHtml(url) + '" class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text" tabindex="-1">' +
        '<div class="predictive-search__image-wrapper">' + imageMarkup + '</div>' +
        '<div class="predictive-search__item-content">' +
          '<p class="predictive-search__item-heading h5">' + escapeHtml(title) + '</p>' +
          priceMarkup +
          '<span class="predictive-search__item-type caption-with-letter-spacing">' + escapeHtml(typeLabel) + '</span>' +
        '</div>' +
      '</a>' +
    '</li>';
  }

  function renderSearchResults(results) {
    var productsHtml = '';
    var collectionsHtml = '';
    var articlesHtml = '';
    var pagesHtml = '';

    if (results.products && results.products.length > 0) {
      productsHtml = '<div class="predictive-search__section">' +
        '<h2 class="predictive-search__heading text-body caption-with-letter-spacing">Produkte</h2>' +
        '<ul class="predictive-search__results-list list-unstyled" role="group">' +
          results.products.map(function (product) { return renderSearchResult(product, 'product'); }).join('') +
        '</ul>' +
      '</div>';
    }

    if (results.collections && results.collections.length > 0) {
      collectionsHtml = '<div class="predictive-search__section">' +
        '<h2 class="predictive-search__heading text-body caption-with-letter-spacing">Kategorien</h2>' +
        '<ul class="predictive-search__results-list list-unstyled" role="group">' +
          results.collections.map(function (collection) { return renderSearchResult(collection, 'collection'); }).join('') +
        '</ul>' +
      '</div>';
    }

    if (results.articles && results.articles.length > 0) {
      articlesHtml = '<div class="predictive-search__section">' +
        '<h2 class="predictive-search__heading text-body caption-with-letter-spacing">Blogs</h2>' +
        '<ul class="predictive-search__results-list list-unstyled" role="group">' +
          results.articles.map(function (article) { return renderSearchResult(article, 'article'); }).join('') +
        '</ul>' +
      '</div>';
    }

    if (results.pages && results.pages.length > 0) {
      pagesHtml = '<div class="predictive-search__section">' +
        '<h2 class="predictive-search__heading text-body caption-with-letter-spacing">Seiten</h2>' +
        '<ul class="predictive-search__results-list list-unstyled" role="group">' +
          results.pages.map(function (page) { return renderSearchResult(page, 'page'); }).join('') +
        '</ul>' +
      '</div>';
    }

    var leftColumn = collectionsHtml + articlesHtml + pagesHtml;
    var rightColumn = productsHtml;

    return '<div id="predictive-search-results" role="listbox">' +
      '<div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper">' +
        (leftColumn ? '<div class="predictive-search__result-group predictive-search__result-group--left">' + leftColumn + '</div>' : '') +
        (rightColumn ? '<div class="predictive-search__result-group predictive-search__result-group--right">' + rightColumn + '</div>' : '') +
      '</div>' +
      '<div id="predictive-search-option-search-keywords" class="predictive-search__search-for-button">' +
        '<button class="predictive-search__item predictive-search__item--term link link--text h5 animate-arrow" tabindex="-1" role="option" aria-selected="false">' +
          '<span data-predictive-search-search-for-text>Alle Ergebnisse anzeigen</span>' +
          '<span class="svg-wrapper"><svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5882 7.8565C10.5882 8.10194 10.5073 8.30811 10.3454 8.47501C10.1835 8.637 9.98978 8.71799 9.76413 8.71799C9.54339 8.71799 9.35454 8.637 9.19756 8.47501C9.0455 8.30811 8.96946 8.1093 8.96946 7.87859V5.2573L9.01152 4.22487C9.0345 3.66059 8.3377 3.37826 7.96141 3.79939L1.44218 10.3232C1.26558 10.4999 1.06692 10.5882 0.846176 10.5882C0.699015 10.5882 0.561665 10.5465 0.434125 10.4631C0.306585 10.3845 0.20112 10.2814 0.117729 10.1538C0.0392429 10.0262 0 9.88873 0 9.74147C0 9.52549 0.0882966 9.32668 0.26489 9.14505L6.77676 2.62129C7.19918 2.25049 6.92349 1.55457 6.36174 1.57365L5.21686 1.61253H2.70776C2.48212 1.61253 2.2859 1.53645 2.11912 1.38428C1.95234 1.22719 1.86895 1.03821 1.86895 0.817312C1.86895 0.596417 1.94988 0.404974 2.11176 0.242985C2.27364 0.0809948 2.47721 0 2.72248 0H9.71263C9.97752 0 10.1884 0.0809948 10.3454 0.242985C10.5024 0.404974 10.5809 0.613597 10.5809 0.868854L10.5882 7.8565Z" fill="white"/></svg></span>' +
        '</button>' +
      '</div>' +
    '</div>';
  }

  function performSearch(query) {
    if (!query || query.length < 2) return Promise.resolve({ products: [], collections: [], articles: [], pages: [] });

    return directRequest('/search', {
      method: 'POST',
      body: JSON.stringify({
        query: query,
        shop_domain: shopDomain,
        locale: locale,
        limit: 10
      })
    }).catch(function (error) {
      console.error('Search backend error:', error);
      return { products: [], collections: [], articles: [], pages: [] };
    });
  }

  function initSearchBackend() {
    var searchInputs = document.querySelectorAll('.search__input');
    var predictiveSearchContainers = document.querySelectorAll('[data-predictive-search]');

    searchInputs.forEach(function (input) {
      var debounceTimer;
      var predictiveContainer = input.closest('.search-modal__form')?.querySelector('[data-predictive-search]');

      input.addEventListener('input', function (e) {
        var query = e.target.value.trim();
        
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          if (query.length >= 2) {
            if (predictiveContainer) {
              predictiveContainer.innerHTML = '<div class="predictive-search__loading-state"><svg class="svg-loader" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="svg-loader__circle" cx="33" cy="33" r="30" stroke="currentColor" stroke-width="6" fill="none" stroke-dasharray="58" stroke-dashoffset="10"></circle></svg></div>';
            }
            
            performSearch(query).then(function (results) {
              if (predictiveContainer) {
                predictiveContainer.innerHTML = renderSearchResults(results);
              }
            });
          } else {
            if (predictiveContainer) {
              predictiveContainer.innerHTML = '';
            }
          }
        }, 300);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchBackend);
  } else {
    initSearchBackend();
  }
})();
